import { ConfigProvider, Empty, Spin } from 'antd'
import MarcaYrm from 'components/Loader/MarcaYrm'
import VazioYrm from 'components/shared/VazioYrm'
import { observarErrosGlobais } from 'utils/registrarErro'
import './assets/fix-blue-style.css';
import './assets/animacoes.css';
import { GlobalStyle } from 'assets/global'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import locale from 'antd/locale/pt_BR'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import { registerServiceWorker } from './serviceWorkerRegistration'
import { antdTheme } from './theme'
import { TemaProvider } from './theme/tema'


// Datas em português no app todo (dias da semana e meses do dayjs)
dayjs.locale('pt-br')

observarErrosGlobais()

// As listas vazias do sistema usam a imagem simples do antd: troca pela da marca
Empty.PRESENTED_IMAGE_SIMPLE = <VazioYrm />

// Todo carregamento do antd (tabelas, Spin) usa a marca YRM animada
Spin.setDefaultIndicator(<MarcaYrm />)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={antdTheme}
      getPopupContainer={() => document.body}
      locale={locale}
      empty={{ image: <VazioYrm /> }}
    >
      <TemaProvider>
        <GlobalStyle />
        <App />
      </TemaProvider>
    </ConfigProvider>
  </React.StrictMode>
)

registerServiceWorker()
